import React, {Component} from 'react';
import {Container} from 'reactstrap';
import {AuthenticatedTemplate, UnauthenticatedTemplate} from '@azure/msal-react';
import Favicon from 'react-favicon'
import {NavMenu} from './NavMenu';
import {Footer} from './Footer';
import '../../styling/StyleSH25.css';

export class Layout extends Component {
    static displayName = Layout.name;

    componentDidMount() {
        document.title = "Cubewraps Nucleus";
    }

    render() {
        return (
            <div className="wrapper">
                <Favicon
                    url="https://lh3.googleusercontent.com/-TgoKPTcoTA8/AAAAAAAAAAI/AAAAAAAAAAA/6KZcI33zZ14/s55-p-k-no-ns-nd/photo.jpg"/>
                <UnauthenticatedTemplate>
                    <NavMenu/>
                </UnauthenticatedTemplate>
                <AuthenticatedTemplate>
                    <NavMenu/>
                </AuthenticatedTemplate>
                <Container tag="main" className="main-content">
                    {this.props.children}
                </Container>
                <Footer/>
            </div>
        );
    }
}
